<template>
    <b-modal
        id="checkoutModal"
        v-model="modalShow"
        size="lg"
        ok-variant="success"
        ok-title="Confirmă"
        cancel-variant="danger"
        cancel-title="Anulează"
        header-bg-variant="dark"
        body-bg-variant="dark"
        hide-footer
        hide-header
        centered
        @hide="$emit('hideTempModal');onHide($event)"
    >

        <div class="modal-body">
            <div class="close-button" @click="$emit('hideTempModal');onHide($event)">X</div>

            <div class="modal-header">
                <span>Am lansat noul POCSketch</span>
            </div>
            <p>Pentru a accesa noua variantă a aplicației, te rugăm să apeși butonul de mai jos!</p>


            <div class="button-confirm" @click="$emit('hideTempModal');modalShow = false;onHideRedirect($event)">Accesează platforma</div>
            <div class="button-confirm" @click="$emit('hideTempModal');modalShow = false;onHide($event)">Închide</div>

        </div>
    </b-modal>
</template>

<script>
    import {BModal, BButton} from 'bootstrap-vue';
    export default {
        name: "UpdateAnnouncement",

        components: {
            BModal,
            BButton,
        },
        props: {
            showModal: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                checked: false,
                modalShow: false
            }
        },
        watch: {
            showModal: {
                handler: function() {
                    this.modalShow = this.showModal
                },
                deep: true
            }
        },
        methods: {
            onHide(evt) {
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                }
            },
            onHideRedirect(evt) {
                window.open('https://smis.ro/poc-sketch', '_blank')
                if(evt.trigger === "backdrop"){
                    evt.preventDefault();
                }
            },
        },
    }
</script>

<style scoped>

.modal-body{
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}
.modal-body >>> .modal-header span {
    font-size: 19px;
    font-weight: 700;
    color: #fff;
}
.modal-body >>> .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    position: relative;
}
.modal-body p{
    color: #fff;
    text-align: center;
    margin-top: 15px;
    font-size: 15px;
}
.custom-switch >>> .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(0.8rem) !important;
}
.close-button{
    position: absolute;
    right: 0;
    top: 0;
    font-size: 11px;
    line-height: 1;
    font-weight: 600;
    color: #fff;
    background: transparent;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.custom-switch >>> .custom-control-label::after {
    top: calc( 0.3125rem + 3px );
    left: calc( -2.8125rem + 4px );
    width: calc( 1.25rem - 5px );
    height: calc( 1.25rem - 5px );
    border-radius: 0.6rem;
    background-size: 41% 18%;
}
.button-confirm{
    color: #fff;
    font-size: 14px;
    border: 1px solid #fff;
    border-radius: 4px;
    text-align: center;
    padding: 5px 10px;
    width: 40%;
    margin-bottom: 5px;
    margin-top: 20px;
}
.button-confirm:hover{
    background: #fff;
    color: #000;
    cursor: pointer;
}
.example{
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 0;
}
.example p{
    margin-bottom: 5px;
}
.switch-box{
    text-align: right;
}
.custom-switch >>> .custom-control-label::after{
    background-color: #8c6984;
}
.custom-switch >>> .custom-control-label::before{
    border-color: #8c6984;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #fff !important;
    line-height: 2 !important;
}
.switch-box:disabled >>> label{
    color: #fff;
}
</style>